import { TextClasses_HangingPunctuationClass_$ctor_Z207A3CFB, TextClasses_UserSelect_$ctor_Z207A3CFB, TextClasses_WhiteSpace_$ctor_Z207A3CFB, TextClasses_TextJustify_$ctor_Z207A3CFB, TextClasses_TextRendering_$ctor_Z207A3CFB, TextClasses_TextOrientation_$ctor_Z207A3CFB, TextClasses_TabSize_$ctor_Z207A3CFB, TextClasses_TextSizeAdjust_$ctor_Z207A3CFB, TextClasses_TextEmphasisColor_$ctor_Z207A3CFB, TextClasses_TextDecorationColor_$ctor_Z207A3CFB, TextClasses_Hyphens_$ctor_Z207A3CFB, TextClasses_Quotes_$ctor_Z207A3CFB, TextClasses_TextUnderlineOffset_$ctor_Z207A3CFB, TextClasses_TextUnderlinePosition_$ctor_Z207A3CFB, TextClasses_TextEmphasisStyle_$ctor_Z207A3CFB, TextClasses_TextEmphasisPosition_$ctor_Z207A3CFB, TextClasses_TextEmphasis_$ctor_Z207A3CFB, TextClasses_TextOverflow_$ctor_Z207A3CFB, TextClasses_TextShadow_$ctor_Z207A3CFB, TextClasses_TextIndent_$ctor_Z207A3CFB, TextClasses_TextTransform_$ctor_Z207A3CFB, TextClasses_TextDecorationSkipInk_$ctor_Z207A3CFB, TextClasses_TextDecorationStyle_$ctor_Z207A3CFB, TextClasses_TextDecorationThickness_$ctor_Z207A3CFB, TextClasses_TextDecorationSkip_$ctor_Z207A3CFB, TextClasses_TextDecorationLine_$ctor_Z207A3CFB, TextClasses_TextDecoration_$ctor_Z207A3CFB, TextClasses_TextAlign_$ctor_Z207A3CFB } from "../Types/Text.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const TextAlign = TextClasses_TextAlign_$ctor_Z207A3CFB(new Property_CssProperty(260));

export const TextAlignLast = TextClasses_TextAlign_$ctor_Z207A3CFB(new Property_CssProperty(261));

export const TextDecoration = TextClasses_TextDecoration_$ctor_Z207A3CFB(new Property_CssProperty(262));

export const TextDecorationLine = TextClasses_TextDecorationLine_$ctor_Z207A3CFB(new Property_CssProperty(264));

export const TextDecorationSkip = TextClasses_TextDecorationSkip_$ctor_Z207A3CFB(new Property_CssProperty(266));

export const TextDecorationThickness = TextClasses_TextDecorationThickness_$ctor_Z207A3CFB(new Property_CssProperty(265));

export const TextDecorationStyle = TextClasses_TextDecorationStyle_$ctor_Z207A3CFB(new Property_CssProperty(268));

export const TextDecorationSkipInk = TextClasses_TextDecorationSkipInk_$ctor_Z207A3CFB(new Property_CssProperty(267));

export const TextTransform = TextClasses_TextTransform_$ctor_Z207A3CFB(new Property_CssProperty(272));

export const TextIndent = TextClasses_TextIndent_$ctor_Z207A3CFB(new Property_CssProperty(269));

export const TextShadow = TextClasses_TextShadow_$ctor_Z207A3CFB(new Property_CssProperty(271));

export const TextOverflow = TextClasses_TextOverflow_$ctor_Z207A3CFB(new Property_CssProperty(270));

export const TextEmphasis = TextClasses_TextEmphasis_$ctor_Z207A3CFB(new Property_CssProperty(273));

export const TextEmphasisPosition = TextClasses_TextEmphasisPosition_$ctor_Z207A3CFB(new Property_CssProperty(275));

export const TextEmphasisStyle = TextClasses_TextEmphasisStyle_$ctor_Z207A3CFB(new Property_CssProperty(276));

export const TextUnderlinePosition = TextClasses_TextUnderlinePosition_$ctor_Z207A3CFB(new Property_CssProperty(278));

export const TextUnderlineOffset = TextClasses_TextUnderlineOffset_$ctor_Z207A3CFB(new Property_CssProperty(277));

export const Quotes = TextClasses_Quotes_$ctor_Z207A3CFB(new Property_CssProperty(226));

export const Hyphens = TextClasses_Hyphens_$ctor_Z207A3CFB(new Property_CssProperty(145));

export const TextDecorationColor = TextClasses_TextDecorationColor_$ctor_Z207A3CFB(new Property_CssProperty(263));

export const TextEmphasisColor = TextClasses_TextEmphasisColor_$ctor_Z207A3CFB(new Property_CssProperty(274));

export const TextSizeAdjust = TextClasses_TextSizeAdjust_$ctor_Z207A3CFB(new Property_CssProperty(279));

export const TabSize = TextClasses_TabSize_$ctor_Z207A3CFB(new Property_CssProperty(258));

export const TextOrientation = TextClasses_TextOrientation_$ctor_Z207A3CFB(new Property_CssProperty(280));

export const TextRendering = TextClasses_TextRendering_$ctor_Z207A3CFB(new Property_CssProperty(281));

export const TextJustify = TextClasses_TextJustify_$ctor_Z207A3CFB(new Property_CssProperty(282));

export const WhiteSpace = TextClasses_WhiteSpace_$ctor_Z207A3CFB(new Property_CssProperty(306));

export const UserSelect = TextClasses_UserSelect_$ctor_Z207A3CFB(new Property_CssProperty(294));

export const HangingPunctuation = TextClasses_HangingPunctuationClass_$ctor_Z207A3CFB(new Property_CssProperty(143));

